














import { defineComponent, Ref, ref }             from '@vue/composition-api';
import { GlobalContexts, useGlobals }            from '@/hooks/use-globals';
import cSectionTitle                             from '@/components/section-title/section-title.component.vue';
import cPlusButton                               from '@/components/custom/buttons/plus-button/plus-button.component.vue';
import { nameModeCreate as vXAxisReportBuilder } from '@/views/x-axis-report/report-edit/views/builder/x-axis-report-builder.route';
import { name as vXAxisReportList }              from '@/views/x-axis-report/report-list/x-axis-report-list.route';
import { getViewStorePath }                      from '@/store/store.helpers';
import cAxisReportListTable                      from './components/axis-report-list-table/axis-report-list-table.component.vue';

export default defineComponent({
  name: 'vXAxisReportList',
  components: {
    cSectionTitle,
    cPlusButton,
    cAxisReportListTable,
  },
  setup() {
    const { i18n, store, router }: GlobalContexts = useGlobals();
    const sectionTitle: Ref<string> = ref(i18n.t('vXAxisReportList.pageTitle')
      .toString());

    const dynamicChart: Ref<string> = ref(i18n.t(`${store.state.i18n.GLOBAL_PATH}.dynamicChart`).toString().toLocaleLowerCase());
    const buttonText: Ref<string> = ref(i18n.t(`${store.state.i18n.GLOBAL_PATH}.buttons.createNew`, [ dynamicChart.value ])
      .toString());

    const onClick = (): void => {
      router.push({ name: vXAxisReportBuilder });
    };

    store.dispatch(`${getViewStorePath(vXAxisReportList)}/getReportList`);

    return {
      sectionTitle,
      buttonText,
      onClick,
    };
  },
});
